export const DAILY_MOODS = {
  kiy:  { id: "kiy",  kanji: "清", reading: "きよ", desc: "清々しい・さわやか",    primary: "#3a8a88", light: "#78bfbb", bg: "#f0f7f6", suggestedThemes: ["work", "love"] },
  shi:  { id: "shi",  kanji: "静", reading: "しず", desc: "落ち着いている・穏やか", primary: "#4a6e38", light: "#8aaa68", bg: "#eff4e8", suggestedThemes: ["family", "calm"] },
  net:  { id: "net",  kanji: "熱", reading: "ねつ", desc: "やる気・燃えている",    primary: "#a03828", light: "#d07058", bg: "#f8eeea", suggestedThemes: ["work", "money"] },
  may:  { id: "may",  kanji: "迷", reading: "まよ", desc: "もやもや・方向が見えない", primary: "#6a4890", light: "#a888c8", bg: "#f3eef8", suggestedThemes: ["calm", "relationship"] },
  tsu:  { id: "tsu",  kanji: "疲", reading: "つか", desc: "疲れた・消耗している",   primary: "#6a6058", light: "#a8a098", bg: "#f2eeea", suggestedThemes: ["health", "calm"] },
  kan:  { id: "kan",  kanji: "感", reading: "かん", desc: "感謝・じわっと嬉しい",   primary: "#8a6820", light: "#d0a848", bg: "#faf4e0", suggestedThemes: ["family", "love"] },
  kana: { id: "kana", kanji: "悲", reading: "かな", desc: "悲しい・重い",           primary: "#0c2880", light: "#3870d0", bg: "#eaf2fc", suggestedThemes: ["calm", "health"] },
  ase:  { id: "ase",  kanji: "焦", reading: "あせ", desc: "焦り・プレッシャー",     primary: "#105888", light: "#4898c8", bg: "#e8f4fb", suggestedThemes: ["calm", "work"] },
  yor:  { id: "yor",  kanji: "喜", reading: "よろ", desc: "嬉しい・ハッピー",       primary: "#883048", light: "#c87888", bg: "#f8eef0", suggestedThemes: ["love", "money"] },
  oso:  { id: "oso",  kanji: "恐", reading: "おそ", desc: "不安・心配ごとがある",   primary: "#2a2a38", light: "#5a5a78", bg: "#ebebf2", suggestedThemes: ["calm", "relationship"] },
};

export const DAILY_MOOD_LIST = Object.values(DAILY_MOODS);

export function getDailyMood(id) {
  return DAILY_MOODS[id] || null;
}

// グラデーション（カード表示用）
export const MOOD_GRADIENTS = {
  kiy:  "linear-gradient(150deg, #c8e8e4 0%, #78bfbb 55%, #3a8a88 100%)",
  shi:  "linear-gradient(150deg, #d8e4c8 0%, #8aaa68 55%, #4a6e38 100%)",
  net:  "linear-gradient(150deg, #f0ccc0 0%, #d07058 55%, #a03828 100%)",
  may:  "linear-gradient(150deg, #e0d4f0 0%, #a888c8 55%, #6a4890 100%)",
  tsu:  "linear-gradient(150deg, #e4e0d8 0%, #a8a098 55%, #6a6058 100%)",
  kan:  "linear-gradient(150deg, #f4e8c0 0%, #d0a848 55%, #8a6820 100%)",
  kana: "linear-gradient(150deg, #c0d8f8 0%, #3870d0 55%, #0c2880 100%)",
  ase:  "linear-gradient(150deg, #d0e8f8 0%, #4898c8 55%, #105888 100%)",
  yor:  "linear-gradient(150deg, #f0d4dc 0%, #c87888 55%, #883048 100%)",
  oso:  "linear-gradient(150deg, #c8c8d8 0%, #5a5a78 55%, #20202e 100%)",
};
